import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import FontIcon from 'components/FontIcon';

const SearchButtonBase = forwardRef((props, ref) => {
  const { searchQueryString, classes, searchButtonIcon, renderSearchBox, onClick } = props;

  const findQueryParam = (param) => {
    if (typeof window !== 'undefined') {
      if ('URLSearchParams' in window) {
        const searchParams = new URLSearchParams(window.location.search);
        if (searchParams.has(param)) {
          return searchParams.get(param);
        }
      }
    }
    return null;
  };

  const inputText = findQueryParam(searchQueryString);
  const { siteSearch360SiteId, siteSearch360SiteResults } = props;

  if (!siteSearch360SiteId || !siteSearch360SiteResults) {
    return null;
  }

  return (
    <div ref={ref} className={classes.container}>
      <button
        className={classes.searchButton}
        onClick={onClick}
        aria-label='Search'
        type='button'
      >
        <FontIcon icon={searchButtonIcon} />
      </button>
      {renderSearchBox(inputText)}
    </div>
  );
});

SearchButtonBase.propTypes = {
  siteSearch360SiteId: PropTypes.string,
  siteSearch360SiteResults: PropTypes.string,
  searchQueryString: PropTypes.string,
  classes: PropTypes.object,
  searchButtonIcon: PropTypes.string,
  renderSearchBox: PropTypes.func,
  onClick: PropTypes.func,
};

export default SearchButtonBase;
